"use client"

import { Col, Row } from "antd"

import PromotionsSkeleton from "@/components/common/Promotions/index.skeleton"
import FlightSearchBoxSkeleton from "@/components/flight/flights/landing/FlightSearchBox.skeleton"
import BannersSkeleton from "@/components/common/Banners.skeleton"
import FlightDealsSkeleton from "@/components/home/Deals/FlightDeals.skeleton"
import FlightCommonRoutesSkeleton from "@/components/flight/flights/landing/FlightCommonRoutes.skeleton"

const FlightLoading = () => {
  return (
    <>
      <Row className="flight" justify='center'>
        <Col span={24}>
          <FlightSearchBoxSkeleton />
        </Col>
        <Col span={24} className="flight__content">
          <BannersSkeleton />
          <PromotionsSkeleton />
          <FlightDealsSkeleton type="DOMESTIC" className="home__deals-flights--box" />
          <FlightDealsSkeleton type='INTERNATIONAL' className="home__deals-flights--box" />
          <FlightCommonRoutesSkeleton />
        </Col>
      </Row>
    </>
  )
}

export default FlightLoading